import type { ReactNode } from 'react';

export const symbol_atr: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M230-160q-45 0-77.5-32.5T120-270q0-45 32.5-77.5T230-380q45 0 77.5 32.5T340-270q0 45-32.5 77.5T230-160Zm500 0q-45 0-77.5-32.5T620-270q0-45 32.5-77.5T730-380q46 0 78 32.5t32 77.5q0 45-32 77.5T730-160ZM402.5-612.5Q370-645 370-690t32.5-77.5Q435-800 480-800t77.5 32.5Q590-735 590-690t-32.5 77.5Q525-580 480-580t-77.5-32.5Z"
		/>
	</svg>
);
